import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 1rem;
`

export const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
`

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 1.5rem;
  text-align: center;
`

export const MapInfo = styled.div`
  background: #f7fafc;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
`

export const MapName = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.5rem;
`

export const MapDescription = styled.p`
  color: #718096;
  margin-bottom: 1rem;
`

export const PermissionsList = styled.div`
  margin-top: 1rem;

  strong {
    display: block;
    margin-bottom: 0.5rem;
    color: #4a5568;
  }
`

export const PermissionItem = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: #edf2f7;
  border-radius: 4px;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: #4a5568;
  text-transform: capitalize;
`

export const Button = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  width: 100%;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;

  ${props =>
    props.$variant === 'primary' || !props.$variant
      ? `
    background: #3182ce;
    color: white;
    
    &:hover:not(:disabled) {
      background: #2c5282;
    }
  `
      : `
    background: #e2e8f0;
    color: #4a5568;
    
    &:hover:not(:disabled) {
      background: #cbd5e0;
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ErrorMessage = styled.div`
  padding: 0.75rem;
  background: #fed7d7;
  color: #c53030;
  border-radius: 4px;
  margin-bottom: 1rem;
  text-align: center;
`

export const LoadingMessage = styled.div`
  text-align: center;
  color: #718096;
  font-size: 1.125rem;
`
